import { ApiError, ApiTellUser } from "../error";
import { getApiErrorMessage } from "./index";

const parseApiStatus = async function (res) {
  if (res.status === 200) {
    const resData = await res.json();
    if (resData.error === 0) {
      return resData;
    } else {
      if (
        "message" in resData ||
        "messages" in resData ||
        "errors" in resData ||
        "errorMessage" in resData
      ) {
        throw new ApiTellUser(getApiErrorMessage(resData));
      } else {
        throw new ApiError("Unknown Error[" + resData.error + "]");
      }
    }
  } else if (res.status === 401) {
    //redirect();
    return false;
  } else {
    throw new ApiError("Strange API error");
  }
};

export default parseApiStatus;
